export class AbstractSearchKeys {

  constructor(
    public abstractFilterType?: string,
    public abstractEnteredSearchFilter?: string,
    public isInReview?: boolean,
    public isReportExcluded?: boolean,
    public recommendedForAdjudication?: boolean,
    public recommendedForReview?: boolean,
    public pageSize?: number,
    public pageNumber?: number,
    public sortColumnName?: string,
    public sortDirection?: string,
    public protocolId?: number,
    public filterByProtocol?: boolean,
    public excludedUsers?: number[],
    public excludeAbstractsRecommendedForReview?: boolean,
    public excludeAbstractsInQcList?: boolean,
    public qcWeek?: string,
    public odpProjectWorkflowId?: number,
    public odpUncodedOnly?: boolean,
    public highPriDisagreementSamplePercent?: number,
    public lowPriDisagreementSamplePercent?: number,
    public fullAgreementSamplePercent?: number,
    ) {}
}
